const getIndexOfAttribute = (id, product, list) => {
  return product.attributes.findIndex(
    (attribute) =>
      attribute.label ===
      list.table.find((item) =>
        item.attributes.find((attributeItem) => attributeItem.attribute === id),
      ).label,
  )
}

export const removeLegacyAttributsFromProducts = (
  products,
  listViewStructure,
) => {
  return products.map((product) => {
    if (product.variant_fields?.storage && product.variant_fields?.color) {
      const storageIndex = getIndexOfAttribute(
        'list_view.storage',
        product,
        listViewStructure,
      )
      const releaseIndex = getIndexOfAttribute(
        'list_view.date_release',
        product,
        listViewStructure,
      )

      return {
        ...product,
        attributes: product.attributes.filter(
          (_, index) => index !== storageIndex && index !== releaseIndex,
        ),
      }
    }

    return product
  })
}
